/**
 * Created by fers on 25.07.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';

interface ActivateFlowMutationProps {
    flow_id: string;
    organisation_id: string;
}

export default class ActivateFlowMutation extends Relay.Mutation<ActivateFlowMutationProps> {
    static propTypes = {
        flow_id: PropTypes.string.isRequired,
        organisation_id: PropTypes.string.isRequired,
    };

    getMutation() {
        return Relay.QL`mutation {activateFlow}`;
    }

    getVariables() {
        return {
            flow_id: this.props.flow_id,
            organisation_id: this.props.organisation_id,
        };
    }

    getFatQuery() {
        return Relay.QL`
          fragment on ActivateFlowPayload {
              clientMutationId,
              updatedNode {
                  id,
                  realId,
                  enabled,
                  activated,
                  deleted,
                  invalid,
                  debug,
                  debugUntil,
                  selectedChannels,
                  channels(first: 100) {
                    edges {
                        node {
                            id,
                        }
                    }
                  },
                  manualButtons(first: 100) {
                    edges {
                        node {
                            id,
                            realId,
                            type,
                            flowStepDef_id,
                            flowStepDef {
                                id,
                                realId,
                                name
                            },
                        }
                    }
                },
                manualForms(first: 100) {
                    edges {
                        node {
                            id,
                            realId,
                            type,
                            flowStepDef_id,
                            flowStepDef {
                                id,
                                realId,
                                key,
                                name
                            },
                        }
                    }
                },
              }
          }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                this.getFatQuery()
            ],
        }];
    }
}
